// Mock Data for Development Mode - Role-Based Access Control

export const mockData = {
    // ============================================
    // SUPER ADMIN USER
    // ============================================
    superAdmin: {
        id: 'super-admin-1',
        email: 'superadmin@system.com',
        firstName: 'System',
        lastName: 'Administrator',
        phone: '+1 (555) 000-0001',
        location: 'System HQ',
        department: 'System Administration',
        isActive: true,
        roles: ['SuperAdmin'],
        createdAt: '2024-01-01T00:00:00Z',
        avatar: 'https://ui-avatars.com/api/?name=System+Administrator&background=9333ea&color=fff',
        // Super Admin has no tenant
        tenant: null,
    },

    // ============================================
    // TENANT OWNER USERS
    // ============================================
    tenantOwners: [
        {
            id: '1',
            email: 'admin@acme.com',
            firstName: 'John',
            lastName: 'Doe',
            phone: '+1 (555) 123-4567',
            location: 'New York, NY',
            department: 'IT Management',
            isActive: true,
            roles: ['TenantOwner'],
            tenantId: '1',
            createdAt: '2024-01-15T00:00:00Z',
            avatar: 'https://ui-avatars.com/api/?name=John+Doe&background=3b82f6&color=fff',
            tenant: {
                id: '1',
                name: 'Acme Corporation',
                slug: 'acme-corp',
                subscriptionPlan: 'Enterprise',
                subscriptionStatus: 'Active',
            },
        },
        {
            id: '4',
            email: 'owner@techcorp.com',
            firstName: 'Sarah',
            lastName: 'Johnson',
            phone: '+1 (555) 234-5678',
            location: 'San Francisco, CA',
            department: 'Operations',
            isActive: true,
            roles: ['TenantOwner'],
            tenantId: '2',
            createdAt: '2024-02-01T00:00:00Z',
            avatar: 'https://ui-avatars.com/api/?name=Sarah+Johnson&background=3b82f6&color=fff',
            tenant: {
                id: '2',
                name: 'TechCorp Industries',
                slug: 'techcorp',
                subscriptionPlan: 'Professional',
                subscriptionStatus: 'Active',
            },
        },
    ],

    // ============================================
    // TENANT USERS
    // ============================================
    users: [
        {
            id: '1',
            email: 'admin@acme.com',
            firstName: 'John',
            lastName: 'Doe',
            phone: '+1 (555) 123-4567',
            location: 'New York, NY',
            department: 'IT Management',
            isActive: true,
            roles: ['TenantOwner'],
            tenantId: '1',
            createdAt: '2024-01-15T00:00:00Z',
            avatar: 'https://ui-avatars.com/api/?name=John+Doe&background=3b82f6&color=fff',
            tenant: {
                id: '1',
                name: 'Acme Corporation',
                slug: 'acme-corp',
                subscriptionPlan: 'Enterprise',
                subscriptionStatus: 'Active',
            },
        },
        {
            id: '2',
            email: 'user@acme.com',
            firstName: 'Jane',
            lastName: 'Smith',
            phone: '+1 (555) 345-6789',
            location: 'Brooklyn, NY',
            department: 'IT Service Desk',
            isActive: true,
            roles: ['TenantUser'],
            tenantId: '1',
            createdAt: '2024-01-20T00:00:00Z',
            avatar: 'https://ui-avatars.com/api/?name=Jane+Smith&background=10b981&color=fff',
            tenant: {
                id: '1',
                name: 'Acme Corporation',
                slug: 'acme-corp',
                subscriptionPlan: 'Enterprise',
                subscriptionStatus: 'Active',
            },
        },
        {
            id: '3',
            email: 'agent@acme.com',
            firstName: 'Bob',
            lastName: 'Wilson',
            phone: '+1 (555) 456-7890',
            location: 'Queens, NY',
            department: 'IT Support',
            isActive: true,
            roles: ['TenantUser'],
            tenantId: '1',
            createdAt: '2024-01-25T00:00:00Z',
            avatar: 'https://ui-avatars.com/api/?name=Bob+Wilson&background=10b981&color=fff',
            tenant: {
                id: '1',
                name: 'Acme Corporation',
                slug: 'acme-corp',
                subscriptionPlan: 'Enterprise',
                subscriptionStatus: 'Active',
            },
        },
        {
            id: '5',
            email: 'agent1@techcorp.com',
            firstName: 'Mike',
            lastName: 'Davis',
            phone: '+1 (555) 567-8901',
            location: 'Palo Alto, CA',
            department: 'Technical Support',
            isActive: true,
            roles: ['TenantUser'],
            tenantId: '2',
            createdAt: '2024-02-05T00:00:00Z',
            avatar: 'https://ui-avatars.com/api/?name=Mike+Davis&background=10b981&color=fff',
            tenant: {
                id: '2',
                name: 'TechCorp Industries',
                slug: 'techcorp',
                subscriptionPlan: 'Professional',
                subscriptionStatus: 'Active',
            },
        },
    ],

    // ============================================
    // ALL TENANTS (Super Admin View)
    // ============================================
    tenants: [
        {
            id: '1',
            name: 'Acme Corporation',
            slug: 'acme-corp',
            isActive: true,
            createdAt: '2024-01-15T00:00:00Z',
            userCount: 3,
            incidentCount: 45,
            subscriptionPlan: 'Enterprise',
            subscriptionStatus: 'Active',
        },
        {
            id: '2',
            name: 'TechCorp Industries',
            slug: 'techcorp',
            isActive: true,
            createdAt: '2024-02-01T00:00:00Z',
            userCount: 5,
            incidentCount: 62,
            subscriptionPlan: 'Professional',
            subscriptionStatus: 'Active',
        },
        {
            id: '3',
            name: 'Global Services Ltd',
            slug: 'global-services',
            isActive: true,
            createdAt: '2024-02-15T00:00:00Z',
            userCount: 2,
            incidentCount: 20,
            subscriptionPlan: 'Starter',
            subscriptionStatus: 'Trial',
        },
    ],

    // ============================================
    // CURRENT TENANT (Tenant Owner/User View)
    // ============================================
    tenant: {
        id: '1',
        name: 'Acme Corporation',
        slug: 'acme-corp',
        isActive: true,
        createdAt: '2024-01-15T00:00:00Z',
        subscriptionPlan: 'Enterprise',
        subscriptionStatus: 'Active',
        settings: {
            timezone: 'America/New_York',
            dateFormat: 'MM/DD/YYYY',
            businessHours: '9:00 AM - 5:00 PM',
        },
    },

    // ============================================
    // TOKENS
    // ============================================
    tokens: {
        accessToken: 'mock_access_token_' + Math.random().toString(36).substr(2, 9),
        refreshToken: 'mock_refresh_token_' + Math.random().toString(36).substr(2, 9),
    },

    // ============================================
    // INVITES
    // ============================================
    invites: [
        {
            id: '1',
            email: 'newuser@acme.com',
            tenantId: '1',
            tenantName: 'Acme Corporation',
            roleId: '2',
            roleName: 'TenantUser',
            token: 'invite-token-123',
            isUsed: false,
            expiresAt: '2024-12-31T23:59:59Z',
            createdAt: '2024-01-30T00:00:00Z',
            invitedBy: 'John Doe',
        },
        {
            id: '2',
            email: 'developer@acme.com',
            tenantId: '1',
            tenantName: 'Acme Corporation',
            roleId: '2',
            roleName: 'TenantUser',
            token: 'invite-token-456',
            isUsed: false,
            expiresAt: '2024-12-31T23:59:59Z',
            createdAt: '2024-02-10T00:00:00Z',
            invitedBy: 'John Doe',
        },
    ],

    // ============================================
    // CUSTOM FIELDS (User-Specific - For Profile)
    // ============================================
    customFields: [
        {
            id: 1,
            tenantId: '1',
            name: 'Phone Number',
            key: 'phone_number',
            type: 'text',
            isRequired: true,
            options: null,
            defaultValue: null,
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 2,
            tenantId: '1',
            name: 'Department',
            key: 'department',
            type: 'select',
            isRequired: false,
            options: ['Engineering', 'Sales', 'Marketing', 'Support', 'HR'],
            defaultValue: 'Engineering',
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 3,
            tenantId: '1',
            name: 'Start Date',
            key: 'start_date',
            type: 'date',
            isRequired: false,
            options: null,
            defaultValue: null,
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 4,
            tenantId: '1',
            name: 'Employee ID',
            key: 'employee_id',
            type: 'number',
            isRequired: true,
            options: null,
            defaultValue: null,
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 5,
            tenantId: '1',
            name: 'Is Manager',
            key: 'is_manager',
            type: 'boolean',
            isRequired: false,
            options: null,
            defaultValue: 'false',
            createdAt: '2024-01-15T00:00:00Z',
        },
    ],

    // ============================================
    // INCIDENT CUSTOM FIELDS (Incident-Specific)
    // ============================================
    incidentCustomFields: [
        {
            id: 101,
            tenantId: '1',
            entityType: 'incident',
            name: 'Location',
            key: 'location',
            type: 'text',
            isRequired: true,
            options: null,
            defaultValue: null,
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 102,
            tenantId: '1',
            entityType: 'incident',
            name: 'Severity Level',
            key: 'severity_level',
            type: 'select',
            isRequired: false,
            options: ['Low', 'Medium', 'High', 'Critical'],
            defaultValue: 'Medium',
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 103,
            tenantId: '1',
            entityType: 'incident',
            name: 'Affected Users Count',
            key: 'affected_users_count',
            type: 'number',
            isRequired: false,
            options: null,
            defaultValue: null,
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 104,
            tenantId: '1',
            entityType: 'incident',
            name: 'Business Impact',
            key: 'business_impact',
            type: 'select',
            isRequired: true,
            options: ['None', 'Low', 'Medium', 'High', 'Severe'],
            defaultValue: 'Low',
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 105,
            tenantId: '1',
            entityType: 'incident',
            name: 'Requires Approval',
            key: 'requires_approval',
            type: 'boolean',
            isRequired: false,
            options: null,
            defaultValue: 'false',
            createdAt: '2024-01-15T00:00:00Z',
        },
        {
            id: 106,
            tenantId: '1',
            entityType: 'incident',
            name: 'Incident Date',
            key: 'incident_date',
            type: 'date',
            isRequired: false,
            options: null,
            defaultValue: null,
            createdAt: '2024-01-15T00:00:00Z',
        },
    ],

    // ============================================
    // CUSTOM FIELD VALUES (User-Specific)
    // ============================================
    customFieldValues: {
        '1': [ // User ID 1 (John Doe)
            { key: 'phone_number', name: 'Phone Number', type: 'text', value: '+1 (555) 123-4567', isRequired: true },
            { key: 'department', name: 'Department', type: 'select', value: 'Engineering', isRequired: false },
            { key: 'start_date', name: 'Start Date', type: 'date', value: '2024-01-15', isRequired: false },
            { key: 'employee_id', name: 'Employee ID', type: 'number', value: '1001', isRequired: true },
            { key: 'is_manager', name: 'Is Manager', type: 'boolean', value: true, isRequired: false },
        ],
        '2': [ // User ID 2 (Jane Smith)
            { key: 'phone_number', name: 'Phone Number', type: 'text', value: '+1 (555) 345-6789', isRequired: true },
            { key: 'department', name: 'Department', type: 'select', value: 'Sales', isRequired: false },
            { key: 'start_date', name: 'Start Date', type: 'date', value: '2024-01-20', isRequired: false },
            { key: 'employee_id', name: 'Employee ID', type: 'number', value: '1002', isRequired: true },
            { key: 'is_manager', name: 'Is Manager', type: 'boolean', value: false, isRequired: false },
        ],
        '3': [ // User ID 3 (Bob Wilson)
            { key: 'phone_number', name: 'Phone Number', type: 'text', value: '+1 (555) 456-7890', isRequired: true },
            { key: 'department', name: 'Department', type: 'select', value: 'Support', isRequired: false },
            { key: 'start_date', name: 'Start Date', type: 'date', value: '2024-01-25', isRequired: false },
            { key: 'employee_id', name: 'Employee ID', type: 'number', value: '1003', isRequired: true },
            { key: 'is_manager', name: 'Is Manager', type: 'boolean', value: false, isRequired: false },
        ],
    },

    // ============================================
    // INCIDENT CUSTOM FIELD VALUES
    // ============================================
    incidentCustomFieldValues: {
        // Incident ID -> Custom Field Values
        'INC-1024': [
            { key: 'location', value: 'Data Center A' },
            { key: 'severity_level', value: 'High' },
            { key: 'affected_users_count', value: '150' },
            { key: 'business_impact', value: 'High' },
            { key: 'requires_approval', value: 'true' },
            { key: 'incident_date', value: '2024-03-15' },
        ],
    },

    // ============================================
    // DASHBOARD METRICS (Tenant-Specific)
    // ============================================
    dashboard: {
        totalIncidents: 45,
        openIncidents: 12,
        criticalIncidents: 3,
        resolvedToday: 8,
        avgResolutionTime: '4.2 hours',
        slaCompliance: 94.5,
        userCount: 3,
        activeUsers: 3,
        recentActivity: [
            {
                id: 'INC-1024',
                type: 'incident',
                title: 'Database connection timeout',
                priority: 'Critical',
                status: 'In Progress',
                assignee: 'John Doe',
                createdAt: '2024-03-15T10:30:00Z',
                tenant: 'Acme Corporation',
            },
            {
                id: 'INC-1023',
                type: 'incident',
                title: 'Email server slow response',
                priority: 'High',
                status: 'Resolved',
                assignee: 'Jane Smith',
                createdAt: '2024-03-15T09:15:00Z',
                tenant: 'Acme Corporation',
            },
            {
                id: 'INC-1022',
                type: 'incident',
                title: 'VPN connectivity issues',
                priority: 'Medium',
                status: 'Open',
                assignee: 'Bob Wilson',
                createdAt: '2024-03-15T08:00:00Z',
                tenant: 'Acme Corporation',
            },
        ],
        performanceData: [
            { month: 'Jan', incidents: 35, resolved: 32, sla: 91 },
            { month: 'Feb', incidents: 42, resolved: 38, sla: 90 },
            { month: 'Mar', incidents: 45, resolved: 40, sla: 94 },
        ],
    },

    // ============================================
    // SUPER ADMIN DASHBOARD (System-Wide)
    // ============================================
    superAdminDashboard: {
        totalTenants: 3,
        activeTenants: 3,
        totalUsers: 10,
        activeUsers: 9,
        totalIncidents: 127,
        criticalIncidents: 8,
        systemHealth: 98.2,
        avgResolutionTime: '3.8 hours',
        slaCompliance: 95.3,
        tenantMetrics: [
            {
                tenantId: '1',
                name: 'Acme Corporation',
                incidents: 45,
                users: 3,
                health: 95,
                plan: 'Enterprise',
                status: 'Active',
            },
            {
                tenantId: '2',
                name: 'TechCorp Industries',
                incidents: 62,
                users: 5,
                health: 99,
                plan: 'Professional',
                status: 'Active',
            },
            {
                tenantId: '3',
                name: 'Global Services Ltd',
                incidents: 20,
                users: 2,
                health: 100,
                plan: 'Starter',
                status: 'Trial',
            },
        ],
        recentActivity: [
            {
                id: 'SYS-001',
                type: 'tenant',
                title: 'New tenant registered: Global Services Ltd',
                priority: 'Info',
                status: 'Completed',
                createdAt: '2024-03-15T11:00:00Z',
                tenant: 'System',
            },
            {
                id: 'SYS-002',
                type: 'system',
                title: 'Database backup completed',
                priority: 'Info',
                status: 'Completed',
                createdAt: '2024-03-15T10:00:00Z',
                tenant: 'System',
            },
            {
                id: 'INC-1024',
                type: 'incident',
                title: 'Critical incident in Acme Corporation',
                priority: 'Critical',
                status: 'In Progress',
                createdAt: '2024-03-15T09:30:00Z',
                tenant: 'Acme Corporation',
            },
        ],
        performanceData: [
            { month: 'Jan', tenants: 2, users: 8, incidents: 98, resolved: 92 },
            { month: 'Feb', tenants: 3, users: 9, incidents: 115, resolved: 108 },
            { month: 'Mar', tenants: 3, users: 10, incidents: 127, resolved: 119 },
        ],
    },

    // ============================================
    // TENANT USER DASHBOARD (Limited View)
    // ============================================
    tenantUserDashboard: {
        myIncidents: 8,
        openIncidents: 3,
        resolvedToday: 2,
        avgResolutionTime: '5.1 hours',
        assignedToMe: [
            {
                id: 'INC-1022',
                title: 'VPN connectivity issues',
                priority: 'Medium',
                status: 'Open',
                createdAt: '2024-03-15T08:00:00Z',
            },
            {
                id: 'INC-1019',
                title: 'Printer offline',
                priority: 'Low',
                status: 'In Progress',
                createdAt: '2024-03-14T14:30:00Z',
            },
        ],
        recentActivity: [
            {
                id: 'INC-1022',
                type: 'incident',
                title: 'VPN connectivity issues assigned to you',
                priority: 'Medium',
                status: 'Open',
                createdAt: '2024-03-15T08:00:00Z',
            },
            {
                id: 'INC-1020',
                type: 'incident',
                title: 'You resolved: Password reset request',
                priority: 'Low',
                status: 'Resolved',
                createdAt: '2024-03-14T16:00:00Z',
            },
        ],
    },
};

// Helper to create mock response
export const createMockResponse = (data, message = 'Success') => ({
    success: true,
    data,
    message,
    code: 'SUCCESS',
    details: null,
});

// Helper to create mock error
export const createMockError = (message, code = 'ERROR', details = null) => ({
    success: false,
    data: null,
    message,
    code,
    details,
});

// Simulate network delay
export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Get user by role (with tenant info embedded)
export const getMockUserByRole = (role) => {
    if (role === 'SuperAdmin') return mockData.superAdmin;
    if (role === 'TenantOwner') return mockData.tenantOwners[0];
    return mockData.users[1]; // Default TenantUser
};

// Get dashboard by role
export const getMockDashboard = (role) => {
    if (role === 'SuperAdmin') return mockData.superAdminDashboard;
    if (role === 'TenantOwner') return mockData.dashboard;
    return mockData.tenantUserDashboard;
};

// Get all users (filtered by role)
export const getMockUsers = (role, tenantId = null) => {
    if (role === 'SuperAdmin') {
        // Super Admin sees all users
        return [mockData.superAdmin, ...mockData.tenantOwners, ...mockData.users];
    }
    if (role === 'TenantOwner') {
        // Tenant Owner sees only their tenant users
        return mockData.users.filter((user) => user.tenantId === tenantId);
    }
    // Tenant User cannot see other users
    return [];
};

// Get all tenants (Super Admin only)
export const getMockTenants = (role) => {
    if (role === 'SuperAdmin') {
        return mockData.tenants;
    }
    return [];
};

// Get custom fields for tenant (User Profile)
export const getMockCustomFields = (tenantId) => {
    return mockData.customFields.filter(field => field.tenantId === tenantId);
};

// Get custom fields for incidents
export const getMockIncidentCustomFields = (tenantId) => {
    return mockData.incidentCustomFields.filter(field => field.tenantId === tenantId);
};

// Get custom field values for user
export const getMockCustomFieldValues = (userId) => {
    return mockData.customFieldValues[userId] || [];
};

// Get incident custom field values
export const getMockIncidentCustomFieldValues = (incidentId) => {
    return mockData.incidentCustomFieldValues[incidentId] || [];
};